import { providers } from '../../providers';
import { wavespeed } from '../wavespeed/index';
import type { TersaSpeechModel } from '../types';
import { elevenlabsVoices } from './voices/elevenlabs-voices';

// 系数
const COST_FACTOR = 2;

export const elevenlabsModels: Record<string, TersaSpeechModel> = {
    'elevenlabs-eleven-v3': {
        promptLabel: 'Text',
        chef: providers.elevenlabs,
        providers: [
            {
                ...providers.elevenlabs,
                model: wavespeed.speech('elevenlabs-eleven-v3'),
                getCost: ({ characters }) => {
                    const units = Math.max(1, Math.ceil((characters ?? 0) / 1000));
                    return units * 0.1 * COST_FACTOR;
                },
            },
        ],
        voices: elevenlabsVoices,
        precheck: ['prompt'],
        supportsInput: ['t2a'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'elevenlabs-voice-changer': {
        chef: providers.elevenlabs,
        providers: [
            {
                ...providers.elevenlabs,
                model: wavespeed.speech('elevenlabs-voice-changer'),
                getCost: ({ durationSeconds }) => {
                    const units = Math.max(1, Math.ceil((durationSeconds ?? 0) / 60));
                    return units * 0.3 * COST_FACTOR;
                },
            },
        ],
        voices: elevenlabsVoices,
        hideInstructions: true,
        precheck: ['audio'],
        supportsInput: ['a2a'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'elevenlabs-music': {
        chef: providers.elevenlabs,
        providers: [
            {
                ...providers.elevenlabs,
                model: wavespeed.speech('elevenlabs-music'),
                getCost: ({ providerOptions }) => {
                    const durations = providerOptions?.duration_seconds || 30;
                    return durations * 0.0083 * COST_FACTOR;
                },
            },
        ],
        voices: ['lyrics', 'Music Mode', 'Instrumental Mode'],
        hideLyricsVoices: ['Instrumental Mode'],
        precheck: ['prompt'],
        supportsInput: ['t2m'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};